import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { setstylist } from "../../actions/setstylistaction";
import AlertDialogBox from "../DailogBoxes/alertdailogbox";
import ErorrDialogBox from "../DailogBoxes/errordaologbox";
import Service from "../../Service/firebase";

const EditStylist = (props) => {
  const [imageFile, setImageFile] = useState(null);
  const [htmlElement, setHtmlElement] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [openAlertDialog, setOpenAlertDialog] = useState(false);
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [vendorCode, setVendorCode] = useState("");
  const [vendorCodeError, setVendorCodeError] = useState("");
  const [stylist, setStylist] = useState({
    name: props.stylist.name || "",
    role: props.stylist.role || "",
    experience: props.stylist.experience || "",
    vendorId: props.stylist.vendorId || "",
    active: props.stylist.active !== undefined ? props.stylist.active : true,
    addedOn: props.stylist.addedOn || "",
    image: props.stylist.image || "",
  });

  useEffect(() => {
    Service.getAllData("vendors").then((list) => {
      if (list.length > 0) {
        setVendors(list);
        const found = list.find((v) => v.uid === props.stylist.vendorId);
        if (found) setVendorCode(found.vendorCode || "");
      }
    });
  }, [props.stylist.vendorId]);

  const handleVendorCodeBlur = (list) => {
    const vList = list || vendors;
    if (vendorCode) {
      const found = vList.find((v) => v.vendorCode === vendorCode);
      if (found) {
        setStylist((prev) => ({ ...prev, vendorId: found.uid }));
        setVendorCodeError("");
      } else {
        setVendorCodeError("Vendor code not found");
      }
    }
  };

  useEffect(() => {
    if (stylist.image) {
      setHtmlElement(
        <img
          style={{ width: 100, height: 100, borderRadius: "50%", objectFit: "cover" }}
          src={stylist.image}
          alt="stylist"
        />
      );
    } else {
      setHtmlElement(<i className="fa fa-user fa-8x" aria-hidden="true"></i>);
    }
  }, [stylist.image]);

  const onEdit = (e) => {
    const { name, value, type, checked } = e.target;
    setStylist((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setImageFile(event.target.files[0]);
      let reader = new FileReader();
      reader.onload = (e) => {
        setStylist((prev) => ({ ...prev, image: e.target.result }));
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (imageFile) {
      onUploadImage(imageFile);
    } else {
      onUpdate(stylist);
    }
  };

  const onUploadImage = async (image) => {
    const url = await Service.uploadImage(image, "stylistImages");
    if (url !== "") {
      const updated = { ...stylist, image: url };
      setStylist(updated);
      onUpdate(updated);
    } else {
      setIsLoading(false);
      setOpenErrorDialog(true);
    }
  };

  const onUpdate = async (data) => {
    const sendData = {
      ...data,
      searchbyname: data.name.toLowerCase().replace(/\s/g, ""),
    };
    const res = await Service.updateData(sendData, "stylists", props.stylist.stylistId);
    if (res === "success") {
      setIsLoading(false);
      setOpenAlertDialog(true);
      props.setOnStylist({ ...sendData, stylistId: props.stylist.stylistId });
    } else {
      setIsLoading(false);
      setOpenErrorDialog(true);
    }
  };

  return isLoading ? (
    <div style={{ textAlign: "center", padding: 40 }}>
      <i className="fas fa-spinner fa-pulse fa-4x" style={{ position: "fixed", top: "50%", left: "50%" }}></i>
    </div>
  ) : (
    <div style={{ padding: "24px", maxWidth: 600, margin: "0 auto" }}>
      <AlertDialogBox
        openDailog={openAlertDialog}
        onSetOpenDailog={() => setOpenAlertDialog(false)}
        title="Updated"
        des="Stylist successfully updated"
      />
      <ErorrDialogBox
        openDailog={openErrorDialog}
        onSetOpenDailog={() => setOpenErrorDialog(false)}
        title="Error"
        des="Something went wrong. Try again"
      />

      <div className="topheader" style={{ marginBottom: 16 }}>
        <ul style={{ listStyle: "none", display: "flex", alignItems: "center", padding: 0, gap: 10 }}>
          <li><i className="fa fa-arrow-circle-o-right fa-2x" aria-hidden="true"></i></li>
          <li><h5>Edit Stylist</h5></li>
        </ul>
      </div>
      <hr />

      <form onSubmit={handleSubmit}>
        {/* Image */}
        <div className="form-group text-center">
          <div style={{ marginBottom: 8 }}>{htmlElement}</div>
          <input type="file" accept="image/*" onChange={onImageChange} />
        </div>

        {/* Vendor Code */}
        <div className="form-group">
          <label>Vendor Code <span style={{ color: "red" }}>*</span></label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter vendor code"
            value={vendorCode}
            onChange={(e) => setVendorCode(e.target.value)}
            onBlur={() => handleVendorCodeBlur()}
            required
          />
          {vendorCodeError && <small style={{ color: "red" }}>{vendorCodeError}</small>}
          {stylist.vendorId && !vendorCodeError && (
            <small style={{ color: "green" }}>
              {vendors.find((v) => v.uid === stylist.vendorId)?.salonName || "Vendor found"}
            </small>
          )}
        </div>

        {/* Name */}
        <div className="form-group">
          <label>Name <span style={{ color: "red" }}>*</span></label>
          <input
            name="name"
            type="text"
            className="form-control"
            value={stylist.name}
            onChange={onEdit}
            required
          />
        </div>

        {/* Role */}
        <div className="form-group">
          <label>Role <span style={{ color: "red" }}>*</span></label>
          <input
            name="role"
            type="text"
            className="form-control"
            value={stylist.role}
            onChange={onEdit}
            required
          />
        </div>

        {/* Experience */}
        <div className="form-group">
          <label>Experience</label>
          <input
            name="experience"
            type="text"
            className="form-control"
            value={stylist.experience}
            onChange={onEdit}
          />
        </div>

        {/* Added On */}
        <div className="form-group">
          <label>Added On</label>
          <input
            name="addedOn"
            type="text"
            className="form-control"
            value={stylist.addedOn}
            onChange={onEdit}
          />
        </div>

        {/* Active */}
        <div className="form-group form-check">
          <input
            name="active"
            type="checkbox"
            className="form-check-input"
            id="editActiveCheck"
            checked={stylist.active}
            onChange={onEdit}
          />
          <label className="form-check-label" htmlFor="editActiveCheck">Active</label>
        </div>

        <button type="submit" className="btn btn-primary">Update</button>
      </form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  stylist: state.stylist || {},
});

const mapDispatchToProps = (dispatch) => ({
  setOnStylist: (p) => dispatch(setstylist(p)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditStylist);
